<template>
<!-- 页脚 -->
  <footer class="footer">
    <div class="start-section">
      <div class="start-content">
        <h2>{{ t('footer.startTitle') }}</h2>
        <div class="start-buttons">
          <a :href="requestTest" target="_blank" rel="noopener noreferrer">
            <button class="tab-btn active">{{ t('footer.requestTest') }}</button>
          </a>
          <router-link to="network/global-network">
            <button class="tab-btn">{{ t('footer.learnMore') }}</button>
          </router-link>
          
        </div>
      </div>
      <div class="start-image">
        <img src="@/assets/home/cycle.png" alt="Growth Cycle">
      </div>
    </div>

    <div class="footer-links">
      <div class="footer-column">
        <h3>{{ t('footer.product') }}</h3>
        <router-link to="/product/ip-transit" @click="scrollToTop">{{ t('footer.ipTransit') }}</router-link>
        <router-link to="/product/cloud-vm" @click="scrollToTop">{{ t('footer.cloudVM') }}</router-link>
        <router-link to="/product/bare-metal" @click="scrollToTop">{{ t('footer.bareMetal') }}</router-link>
        <router-link to="/product/sdwan" @click="scrollToTop">{{ t('footer.sdwan') }}</router-link>
      </div>

      <div class="footer-column">
        <h3>{{ t('footer.network') }}</h3>
        <router-link to="/network/global-network" @click="scrollToTop">{{ t('footer.globalNetwork') }}</router-link>
        <router-link to="/network/locations" @click="scrollToTop">{{ t('footer.locations') }}</router-link>
        <router-link to="/network/latency" @click="scrollToTop">{{ t('footer.latency') }}</router-link>
        <router-link to="/network/ddos-shield" @click="scrollToTop">{{ t('footer.ddosShield') }}</router-link>
      </div>

      <div class="footer-column">
        <h3>{{ t('footer.company') }}</h3>
        <router-link to="/company/about" @click="scrollToTop">{{ t('footer.about') }}</router-link>
        <router-link to="/company/careers" @click="scrollToTop">{{ t('footer.careers') }}</router-link>
      </div>

      <div class="footer-column">
        <h3>{{ t('footer.support') }}</h3>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.contactSupport') }}</a>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.contactSales') }}</a>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.documentation') }}</a>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.networkStatus') }}</a>
      </div>

      <div class="footer-column">
        <h3>{{ t('footer.terms') }}</h3>
        <router-link to="/terms/service" @click="scrollToTop">{{ t('footer.termsOfService') }}</router-link>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.compliance') }}</a>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.privacyPolicy') }}</a>
        <a href="javascript:void(0)" class="disabled-link">{{ t('footer.serviceLevel') }}</a>
      </div>
    </div>

    <div class="footer-bottom">
      <!-- 左侧状态显示 -->
      <div class="status">
        <img src="@/assets/icon/Shape.svg" alt="status" width="14" height="14" />
        <span>{{ t('footer.systemStatus') }}</span>
      </div>

      <!-- 中间 Logo -->
      <div class="footer-logo">
        <img src="@/assets/logo.svg" alt="ctcsci" height="24" />
      </div>

      <!-- 右侧语言选择 -->
      <div class="location">
        <img 
          :src="flagSrc"
          :alt="currentLang === 'zh' ? 'China' : 'United States'"
          height="24"
        />
        <span>{{ currentLang === 'zh' ? 'Chinese' : 'United States' }}</span>
        <span class="divider">|</span>
        <span>{{ currentLang === 'zh' ? '简体中文' : 'English' }}</span>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useTranslation } from '@/utils/i18n'
import { computed, ref } from 'vue'
// 导入图片
import usFlag from '@/assets/home/us.svg'
import cnFlag from '@/assets/home/china.svg'

const { t } = useTranslation()
const currentLang = ref(localStorage.getItem('language') || 'en')

const flagSrc = computed(() => {
  return currentLang.value === 'zh' ? cnFlag : usFlag
})

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}
</script>

<script>
export default {
  data() {
    return {
      requestTest: 'mailto:business@ctcsci.com?subject=request test for ip transit' // 替换为目标链接
    };
  }
};
</script>

<style scoped>
.start-section {
  max-width: 1200px;
  margin: 20px auto 80px;
  padding: 50px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 0px;
  box-shadow: 8px 8px 0 #fafafa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 40px;
  padding-right: 100px;
}
.start-content {
  flex: 2;
  max-width: 500px;
}
.start-content h2 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 100px;
  line-height: 1.3;
}
.start-buttons {
  display: flex;
  gap: 20px;
}

.start-image {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.start-image img {
  width: 100%;
  max-width: 200px;
  height: auto;
}

.footer {
  /* border: 1px solid #eaeaea; */
  padding: 80px 0 20px;
  margin-top: auto;
}

.footer-links {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  margin-bottom: 40px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-column h3 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 25px;
  color: #000;
}

.footer-column a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  line-height: 40px;
  transition: color 0.3s ease;
  font-weight: 500;
}

.footer-column a:hover {
  color: #007AFF;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
  border-top: 1px solid #eaeaea;
  padding-top: 20px;
}

.status {
  display: flex;
  align-items: center;
  gap: 8px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.location {
  display: flex;
  align-items: center;
  gap: 8px;
}

.divider {
  color: #eaeaea;
  margin: 0 4px;
}

img {
  display: block;
}

.logo-text {
  font-weight: 500;
}

.disabled-link {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.7);
  font-size: 16px;
  font-weight: 700;
  cursor: not-allowed;
}

.disabled-link:hover {
  color: rgba(0, 0, 0, 0.7); /* 禁用悬停效果 */
}

/* 添加响应式布局 */
@media (max-width: 1024px) {
  .start-section {
    padding: 40px;
    padding-right: 40px;
  }

  .start-content h2 {
    font-size: 32px;
  }

  .start-image img {
    max-width: 180px;
  }
}

@media (max-width: 768px) {
  .start-section {
    flex-direction: column;
    padding: 30px 20px;
    text-align: center;
    margin: 20px 20px 40px;
  }

  .start-content h2 {
    font-size: 28px;
    margin-bottom: 30px;
  }

  .start-buttons {
    flex-direction: column;
    gap: 15px;
  }

  .start-image {
    margin-top: 30px;
  }

  .start-image img {
    max-width: 150px;
  }

  .footer-links {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px 20px;
    padding: 0;
    margin: 0 20px 40px;
    justify-content: center;
    text-align: center;
  }

  .footer-column {
    margin-bottom: 0;
    align-items: center;
    text-align: center;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    text-align: center;
    margin: 0 20px;
  }

  .status, .footer-logo, .location {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .start-section {
    padding: 20px;
    margin: 10px 20px 30px;
  }

  .start-content h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  .footer-links {
    gap: 25px 15px;
    text-align: center;
  }

  .footer-column {
    margin-bottom: 0;
    text-align: center;
  }

  .footer-column h3 {
    margin-bottom: 12px;
  }
}
</style> 